export const sportsIconMap = {
  27: "i-american-football",
  25: "i-baseball",
  15: "i-basketball",
  20: "i-biathlon",
  9: "i-cyclocross",
  1: "i-cycling",
  16: "i-dakar",
  8: "i-darts",
  35: "i-entertainment",
  3: "i-formulaone",
  7: "i-football",
  10: "i-golf",
  21: "i-hand-ball",
  26: "i-ice-hockey",
  2: "i-ice-speed-skating",
  34: "i-mix-martial-arts",
  6: "i-moto-gp",
  12: "i-olympic",
  19: "i-rugby",
  33: "i-ski-jumping",
  17: "i-skiiing",
  11: "i-snooker",
  5: "i-tennis"
};

export const sportsSlugIdMap = {
  cycling: 1,
  skating: 2,
  formula1: 3,
  tennis: 5,
  motogp: 6,
  soccer: 7,
  darts: 8,
  cyclocross: 9,
  golf: 10,
  snooker: 11,
  olympics: 12,
  basketball: 15,
  dakar: 16,
  skiing: 17,
  rugby: 19,
  biathlon: 20,
  handball: 21,
  crosscountry: 23,
  baseball: 25,
  icehockey: 26,
  americanfootball: 27,
  skijumping: 33,
  mma: 34,
  entertainment: 35
};
